var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
// SPDX-FileCopyrightText: 2023 Félix Robles <felix@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
import { useEffect, useState } from "react";
import { Create, EditBase } from "react-admin";
import { PageHeaderStyles } from "../../components/styles/PageHeaderStyles";
import { useQuery } from "@apollo/client";
import { GET_AREAS_EXTENDED } from "@/queries/GetAreasExtended";
import { FormContent } from "./FormContent";
/**
 * Component for creating or editing an Area resource.
 *
 * This component handles both the creation and editing of an Area, depending on whether an `id` is provided.
 * It fetches area data using the `GET_AREAS_EXTENDED` query and conditionally renders either the `EditBase`
 * or `Create` component. The form content is rendered once the required data is available.
 *
 * @param props - The props for the UpsertArea component.
 * @param props.record - The initial record data for the Area (optional).
 * @param props.id - The ID of the Area to edit (if editing).
 * @param props.electionEventId - The ID of the election event associated with the Area.
 * @param props.close - Callback function to close the form/modal.
 *
 * @returns A React element that renders the Area form for creation or editing, or null while loading.
 */
export var UpsertArea = function (props) {
    var record = props.record, id = props.id, electionEventId = props.electionEventId, close = props.close;
    var _a = useState(false), renderUI = _a[0], setRenderUI = _a[1];
    var areas = useQuery(GET_AREAS_EXTENDED, {
        variables: {
            electionEventId: electionEventId,
            areaId: id,
        },
    }).data;
    useEffect(function () {
        if (areas || record) {
            setRenderUI(true);
        }
    }, [areas, record]);
    if (renderUI) {
        return (_jsx(_Fragment, { children: id ? (_jsx(EditBase, __assign({ id: id, resource: "sequent_backend_area", mutationMode: "pessimistic", redirect: false }, { children: _jsx(PageHeaderStyles.Wrapper, { children: _jsx(FormContent, { record: record, id: id, electionEventId: electionEventId, close: close }) }) }))) : (_jsx(Create, __assign({ resource: "sequent_backend_area", redirect: false }, { children: _jsx(PageHeaderStyles.Wrapper, { children: _jsx(FormContent, { record: record, id: id, electionEventId: electionEventId, close: close }) }) }))) }));
    }
    else {
        return null;
    }
};
